import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50 w-full">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#FF9933]/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[#1E3A5F]/10 rounded-full blur-3xl"></div>
      </div>

      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 relative z-10">
        <div className="text-center space-y-6 sm:space-y-8">
          {/* Main heading */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F] leading-tight px-2">
            Un site internet simple, moderne et{' '}
            <span className="text-[#FF9933]">prêt à attirer vos clients</span>
          </h1>

          {/* Subtitle with correction applied */}
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-700 font-semibold max-w-4xl mx-auto px-2 leading-relaxed">
            Je crée une première ébauche gratuite de votre site,{' '}
            <span className="text-[#FF9933]">sans engagement</span>
          </p>

          {/* Value proposition box */}
          <div className="bg-gradient-to-r from-[#FF9933] to-[#E68A2E] text-white rounded-2xl p-6 sm:p-8 max-w-3xl mx-auto shadow-2xl">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-4">
              <CheckCircle size={36} className="flex-shrink-0" />
              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center sm:text-left">
                Vous voyez le résultat avant de payer quoi que ce soit
              </p>
            </div>
            <p className="text-base sm:text-lg md:text-xl text-white/90 text-center">
              Aucun risque, aucune surprise. Vous décidez après avoir vu votre ébauche en ligne.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center pt-4 sm:pt-6 px-2">
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#1E3A5F] hover:bg-[#2A4A6F] text-white text-base sm:text-lg px-6 sm:px-10 py-6 sm:py-7 shadow-lg hover:shadow-xl transition-all duration-300 group w-full sm:w-auto"
            >
              <span className="truncate">Demander mon ébauche gratuite</span>
              <ArrowRight className="ml-2 flex-shrink-0 group-hover:translate-x-1 transition-transform duration-200" />
            </Button>
            <Button
              onClick={() => scrollToSection('how-it-works')}
              variant="outline"
              className="border-2 border-[#1E3A5F] text-[#1E3A5F] hover:bg-[#1E3A5F] hover:text-white text-base sm:text-lg px-6 sm:px-10 py-6 sm:py-7 transition-all duration-300 w-full sm:w-auto"
            >
              Comment ça fonctionne ?
            </Button>
          </div>

          {/* Badges - CORRECTION: Badge "Livraison" supprimé */}
          <div className="grid grid-cols-2 gap-6 sm:gap-8 md:gap-12 max-w-2xl mx-auto pt-8 sm:pt-12 px-2">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#FF9933]">100%</div>
              <div className="text-xs sm:text-sm md:text-base text-gray-600 mt-1">Sans engagement</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#FF9933]">Support</div>
              <div className="text-xs sm:text-sm md:text-base text-gray-600 mt-1">7j/7</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
